export default "__VITE_ASSET__CMKvRdPw__"